import React, { useContext } from 'react';

import TileImageCarousel from './imageCarousel';
import DiscoveryContextV2 from '../../../../contexts/discoveryContext/contextV2';

const TileNavigation = ({
  subCategoryLinks,
  locationLinks,
  trackSubCategoryClick,
  trackSubCategoryArrowClick,
  trackLocationClick,
  trackLocationArrowClick,
}) => {
  const {
    filters: {
      location: { isLocationSetByUser },
    },
    activeFilters: { tag, distance },
  } = useContext(DiscoveryContextV2);

  const hideFilterByType = distance || tag;

  return (
    <>
      {!hideFilterByType && (
        <TileImageCarousel
          title="Filter by type"
          links={subCategoryLinks}
          onTileClick={trackSubCategoryClick}
          onArrowClick={trackSubCategoryArrowClick}
        />
      )}
      {!isLocationSetByUser && locationLinks && locationLinks.length > 0 && (
        <TileImageCarousel
          title="Filter by location"
          links={locationLinks}
          onArrowClick={trackLocationArrowClick}
          onTileClick={trackLocationClick}
        />
      )}
    </>
  );
};

export default TileNavigation;
